import { Box } from "./Box";
import { VScrollBar } from "./VScrollBar";
import { HScrollBar } from "./HScrollBar";
import { Event } from "../events/Event";
import { Rectangle } from "../maths/Rectangle";
import { HideFlags } from "../Const";
import { ScrollType } from "./Styles";
import { TransformKind } from "../display/SpriteConst";
export class Panel extends Box {
    constructor() {
        super();
        this._usedCache = null;
        this._elasticEnabled = false;
        this._scrollType = 0;
        this.width = this.height = 0;
    }
    destroy(destroyChild = true) {
        super.destroy(destroyChild);
        this._vScrollBar = null;
        this._hScrollBar = null;
        this._content = null;
    }
    createChildren() {
        this._content = new PanelContentBox();
        this._content.hideFlags = HideFlags.HideAndDontSave;
        this.addChild(this._content);
        this._setContainer(this._content);
    }
    _panelChildChanged(child) {
        if (child) {
            if (child.parent)
                child.on(Event.RESIZE, this, this._setScrollChanged);
            else
                child.off(Event.RESIZE, this, this._setScrollChanged);
            this._setScrollChanged();
        }
    }
    changeScroll() {
        this._scrollChanged = false;
        var contentW = this.contentWidth || 1;
        var contentH = this.contentHeight || 1;
        var vscroll = this._vScrollBar;
        var hscroll = this._hScrollBar;
        var vShow = vscroll && contentH > this._height;
        var hShow = hscroll && contentW > this._width;
        var showWidth = vShow ? this._width - vscroll.width : this._width;
        var showHeight = hShow ? this._height - hscroll.height : this._height;
        if (vscroll) {
            vscroll.height = this._height - (hShow ? hscroll.height : 0);
            vscroll.scrollSize = Math.max(this._height * 0.033, 1);
            vscroll.thumbPercent = showHeight / contentH;
            vscroll.setScroll(0, contentH - showHeight);
        }
        if (hscroll) {
            hscroll.width = this._width - (vShow ? vscroll.width : 0);
            hscroll.scrollSize = Math.max(this._width * 0.033, 1);
            hscroll.thumbPercent = showWidth / contentW;
            hscroll.setScroll(0, contentW - showWidth);
        }
    }
    _sizeChanged() {
        super._sizeChanged();
        this.setContentSize(this._width, this._height);
    }
    get contentWidth() {
        let max = 0;
        for (let child of this.children) {
            max = Math.max(child._x + child.width * child.scaleX - child.pivotX, max);
        }
        return max;
    }
    get contentHeight() {
        let max = 0;
        for (let child of this.children) {
            max = Math.max(child._y + child.height * child.scaleY - child.pivotY, max);
        }
        return max;
    }
    setContentSize(width, height) {
        let content = this._content;
        content.width = width;
        content.height = height;
        content._scrollRect || (content.scrollRect = new Rectangle());
        content._scrollRect.setTo(0, 0, width, height);
        content.scrollRect = content.scrollRect;
    }
    _transChanged(kind) {
        super._transChanged(kind);
        if ((kind & TransformKind.Size) != 0)
            this._setScrollChanged();
    }
    get scrollType() {
        return this._scrollType;
    }
    set scrollType(value) {
        this._scrollType = value;
        if (this._scrollType == ScrollType.None) {
            if (this._hScrollBar) {
                this._hScrollBar.destroy();
                this._hScrollBar = null;
            }
            if (this._vScrollBar) {
                this._vScrollBar.destroy();
                this._vScrollBar = null;
            }
        }
        else if (this._scrollType == ScrollType.Horizontal) {
            if (this._vScrollBar) {
                this._vScrollBar.destroy();
                this._vScrollBar = null;
            }
            if (this._hScrollBar)
                this._hScrollBar.skin = this._hScrollBarSkin;
            else
                this.createHScrollBar();
        }
        else if (this._scrollType == ScrollType.Vertical) {
            if (this._hScrollBar) {
                this._hScrollBar.destroy();
                this._hScrollBar = null;
            }
            if (this._vScrollBar)
                this._vScrollBar.skin = this._vScrollBarSkin;
            else
                this.createVScrollBar();
        }
        else {
            if (this._hScrollBar)
                this._hScrollBar.skin = this._hScrollBarSkin;
            else
                this.createHScrollBar();
            if (this._vScrollBar)
                this._vScrollBar.skin = this._vScrollBarSkin;
            else
                this.createVScrollBar();
        }
    }
    createHScrollBar() {
        let scrollBar = this._hScrollBar = new HScrollBar();
        scrollBar.hideFlags = HideFlags.HideAndDontSave;
        scrollBar.on(Event.CHANGE, this, this.onScrollBarChange, [scrollBar]);
        scrollBar.target = this._content;
        scrollBar.elasticDistance = this._elasticEnabled ? 200 : 0;
        scrollBar.bottom = 0;
        scrollBar._skinBaseUrl = this._skinBaseUrl;
        scrollBar.skin = this._hScrollBarSkin;
        scrollBar.on(Event.LOADED, this, this._setScrollChanged);
        this._addChild(scrollBar);
        this._setScrollChanged();
    }
    createVScrollBar() {
        let scrollBar = this._vScrollBar = new VScrollBar();
        scrollBar.hideFlags = HideFlags.HideAndDontSave;
        scrollBar.on(Event.CHANGE, this, this.onScrollBarChange, [scrollBar]);
        scrollBar.target = this._content;
        scrollBar.elasticDistance = this._elasticEnabled ? 200 : 0;
        scrollBar.right = 0;
        scrollBar._skinBaseUrl = this._skinBaseUrl;
        scrollBar.skin = this._vScrollBarSkin;
        scrollBar.on(Event.LOADED, this, this._setScrollChanged);
        this._addChild(scrollBar);
        this._setScrollChanged();
    }
    get vScrollBarSkin() {
        return this._vScrollBarSkin;
    }
    set vScrollBarSkin(value) {
        if (value == "")
            value = null;
        if (this._vScrollBarSkin != value) {
            this._vScrollBarSkin = value;
            if (value) {
                if (this._scrollType == 0)
                    this.scrollType = ScrollType.Vertical;
                else if (this._scrollType == ScrollType.Horizontal)
                    this.scrollType = ScrollType.Both;
                else
                    this.scrollType = this._scrollType;
            }
        }
    }
    get hScrollBarSkin() {
        return this._hScrollBarSkin;
    }
    set hScrollBarSkin(value) {
        if (value == "")
            value = null;
        if (this._hScrollBarSkin != value) {
            this._hScrollBarSkin = value;
            if (value) {
                if (this._scrollType == 0)
                    this.scrollType = ScrollType.Horizontal;
                else if (this._scrollType == ScrollType.Vertical)
                    this.scrollType = ScrollType.Both;
                else
                    this.scrollType = this._scrollType;
            }
        }
    }
    get vScrollBar() {
        return this._vScrollBar;
    }
    get hScrollBar() {
        return this._hScrollBar;
    }
    get content() {
        return this._content;
    }
    onScrollBarChange(scrollBar) {
        let rect = this._content._scrollRect;
        if (rect) {
            let start = Math.round(scrollBar.value);
            scrollBar.isVertical ? rect.y = start : rect.x = start;
            this._content.scrollRect = rect;
        }
    }
    scrollTo(x = 0, y = 0) {
        if (this.vScrollBar)
            this.vScrollBar.value = y;
        if (this.hScrollBar)
            this.hScrollBar.value = x;
    }
    refresh() {
        this.changeScroll();
    }
    get cacheAs() {
        return super.cacheAs;
    }
    set cacheAs(value) {
        super.cacheAs = value;
        this._usedCache = null;
        if (value !== "none") {
            this._hScrollBar && this._hScrollBar.on(Event.START, this, this.onScrollStart);
            this._vScrollBar && this._vScrollBar.on(Event.START, this, this.onScrollStart);
        }
        else {
            this._hScrollBar && this._hScrollBar.off(Event.START, this, this.onScrollStart);
            this._vScrollBar && this._vScrollBar.off(Event.START, this, this.onScrollStart);
        }
    }
    get elasticEnabled() {
        return this._elasticEnabled;
    }
    set elasticEnabled(value) {
        this._elasticEnabled = value;
        if (this._vScrollBar) {
            this._vScrollBar.elasticDistance = value ? 200 : 0;
        }
        if (this._hScrollBar) {
            this._hScrollBar.elasticDistance = value ? 200 : 0;
        }
    }
    onScrollStart() {
        this._usedCache || (this._usedCache = super.cacheAs);
        super.cacheAs = "none";
        this._hScrollBar && this._hScrollBar.once(Event.END, this, this.onScrollEnd);
        this._vScrollBar && this._vScrollBar.once(Event.END, this, this.onScrollEnd);
    }
    onScrollEnd() {
        super.cacheAs = this._usedCache;
    }
    _setScrollChanged() {
        if (!this._scrollChanged && !this._destroyed) {
            this._scrollChanged = true;
            this.callLater(this.changeScroll);
        }
    }
}
class PanelContentBox extends Box {
    _childChanged(child) {
        super._childChanged(child);
        this._parent && this._parent._panelChildChanged(child);
    }
}
